import type { IllustrationMap } from '@/components/Illustration/types'
import { PinIntroEnpalIcon } from '@/components/Icons/SwitchToMobileIcons/PinIntroEnpalIcon'

export const enpalIllustrations: Partial<IllustrationMap> = {
  'pin-intro': { component: PinIntroEnpalIcon },
}
